import { render, staticRenderFns } from "./VehicleAutoAdvertFotos.vue?vue&type=template&id=5b823db2&"
import script from "./VehicleAutoAdvertFotos.vue?vue&type=script&lang=js&"
export * from "./VehicleAutoAdvertFotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports